///members.js
import React, { useEffect, useState } from "react";
import { isAuthenticated } from "../../../auth";
import { formatDateAndTime, startLoader, stopLoader } from "../../../lib/utils";
import Link from "react-router-dom/Link";
import ManageEnquiry from "../../../features/enquiry/modals/manage-enquiry";
import MembershipBillingController from "../../membershipBilling";
import { getAllMemberships } from "../../../features/memberships/helper/api";
import "../../../features/member/style.scss";
import { getPaymentByMembershipId } from "../../../features/payments/helper/api";
import Toast from "../../../lib/toast";
import PaymentSlip from "../../../features/payments/Components/payment-slip";
import { getCustomers } from "../helper/api";
import { useHistory } from "react-router-dom";
import ModalDrawer from "../../../components/modal-drawer";

const MemberSearch = (props) => {

  const {user,token} = isAuthenticated(); 
  var [pageNo, setPageNo] = useState(1);
  const pageSize = 20;
  const [customers, setCustomers] = useState([]);
  const [isEnquiryModalOpen, setEnquiryModalOpen] = useState(false);
  const [isMemberSpinnerLoader, setMemberSpinnerLoader] = useState(false);
  const [isNewSale, setNewSale] = useState(false);
  const [isCloseNewSale, setCloseNewSale] = useState(false);
  const [selectedEnquiry, setSelectedEnquiry] = useState("");
  const [activeMemberships,setActiveMemberships] = useState([]);
  const [selectedMember, setSelectedMember] = useState("");
  const [isCloseMembershipModalOpen, setCloseMembershipModalOpen] = useState(false);
  const [startActiveMembershipLoader, setStartActiveMembershipLoader] = useState(false);
  const [selectedMembershipListIndex, setSelectedMembershipListIndex] = useState(-1);
  const [isPaymentBillVisible, setPaymentBillVisible] = useState(false);
  const [billInfo, setBillInfo] = useState("");
  const [hasMore,setHasMore] = useState(false);
  const history = useHistory();
  
  const GetMemberships = async (memberId, type) =>{
    try{
      startLoader();
      let params = {
        memberId,
        status:'active',
        isTrainer:(user?.role == 2 || user?.role == 5)?true:false,
        noLimit:'noLimit'
      }
      
      let response = await getAllMemberships(user._id,token,params);
      
      if(!response.error){
        if(type == "close-membership"){
          setCloseMembershipModalOpen(true);
        }
        setActiveMemberships(response);
      }
      
      stopLoader();
    }catch(error){

    }
    stopLoader();
  }

  const getMembershipColor = (membership) => {
    const now = new Date();

    const startStr = membership?.starts_at_string;
    const endStr = membership?.ends_at_string;

    if (!startStr || !endStr) return "#000000";

    const parseDate = (str) => {
      const [day, month, year] = str.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    const start = parseDate(startStr);
    const end = parseDate(endStr);

    if (start > now) {
      return "#b6a100";
    }

    if (start <= now && end >= now) {
      return "#5d883c";
    }

    if (end < now) {
      return "#E33A34";
    }

    return "";
  };

  const handleViewMembershipList = (index) => {
    if(selectedMembershipListIndex != index){
      setSelectedMembershipListIndex(index);
      GetMemberships(customers[index]._id);
    }else{
      setSelectedMembershipListIndex(-1);
    }
  }
  
  const toggleEnquiryModal = () => {
    setEnquiryModalOpen(!isEnquiryModalOpen);
  }

  const handleNewSaleModal = () => {
    setNewSale(true);
  }

  const toggleNewSalesModal = (salesModal) => {
    setNewSale(!isNewSale);
  }

  const handleNewSale = (enqInfo) => {
    setSelectedEnquiry(enqInfo);
    setCloseNewSale(true);
  }

  const handleCloseNewSalesBilling = () => {
    setCloseNewSale(!isCloseNewSale);
  }

  const handleScroll = async event => {
    const { offsetHeight, scrollTop, scrollHeight } = event.target;

    if (offsetHeight + scrollTop >= scrollHeight - 100 && !isMemberSpinnerLoader && hasMore) {      
     
      const page = pageNo + 1;
      setPageNo(page)
      setMemberSpinnerLoader(true);
      await GetCustomers();
      setMemberSpinnerLoader(false)
    }
  }


  const GetMemberParams = () => {
    let params = {
      pageNo: pageNo,
      pageSize: pageSize,
    };
    if (props.searchInput) params.q = props.searchInput;
    params.branchId = localStorage.getItem("branchId");
    return params;
  }


  const GetCustomers = async (isReload) => {

    const params = GetMemberParams();

    try {

      let response = await getCustomers(user._id, token, params);


      if (!response.error) {
        await Promise.all(response.data.map(data=>{
          if(data.isEnquiry && !data?.user?.length){
            data.user = [
              {
                name:data?.userInfo?.name  || data?.userInfo?.full_name,
                phone:data?.userInfo?.phone,
                email:data?.userInfo?.name
              }
            ]
          }
        }))
        console.log(response.data);
        if(isReload) setCustomers(response.data);
        else setCustomers(prev => [...prev, ...response.data]);
        setHasMore(response?.pagination?.hasMore?true:false);
      }
    } catch (error) {
      //do something
    }
  }


  const handleCloseMembership = (memberInfo) => {
    GetMemberships(memberInfo._id, "close-membership");
    setSelectedMember(memberInfo);    
  }

  const closeMembershipAssignModal = () => {
    setCloseMembershipModalOpen(false);
  }

  const handleCreatedMembershipId = async(membershipId) => {

    if(membershipId != null){
      try{
        startLoader();
        const response = await getPaymentByMembershipId(user._id,token,membershipId);

        if(!response.error){
          
          setBillInfo(response);

          new Toast({
            type:'success',
            message:"Payment Info Fetched Successfully",
            duration:3000
          })
        }else{
          new Toast({
            type:'error',
            message:"Couldn't Fetch Payment Info, Something went Wrong !",
            duration:3000
          })
        }
        stopLoader();
      }catch(err){
        new Toast({
          type:'error',
          message:"Couldn't Fetch Payment Info, Something went Wrong !",
          duration:3000
        })
      }
    }
  }

  const handleViewPaymentSlip = () => {
    setPaymentBillVisible(false);
  }

  const handleCheckFollowUp = (phone) => {
    history.push(`/follow-up?search=${encodeURIComponent(phone)}`);
  };

  const viewEnquiry = (phone) => {
    history.push(`/enquiries?search=${encodeURIComponent(phone)}`);
  }


  useEffect(() => {
    setPaymentBillVisible(true);
  },[billInfo])

  useEffect(async() => {
    
    try{
      startLoader();
      GetCustomers(true);
      stopLoader();
    }catch(err){
      console.log(err);
    }
  },[props.searchInput])

  return[
    <div onScroll={handleScroll} className="member-search-container">
      {
        window.innerWidth > 640 && (
          <div className="member-list-container member-list-container-header d-flex space-between" style={{position:"sticky", top: 0, zIndex:2, background:"var(--darkBlue)", borderBottom:"1px solid #cfecff"}}>
            <div style={{width:"20%"}}>
              <p className="flex-item font-weight-600 fs-16 color-white">Name</p>
            </div>
            <div className="d-flex" style={{width:"15%"}}>
              <p className="flex-item font-weight-600 fs-16 color-white">Phone</p>
            </div>
            <div className="d-flex" style={{width:"25%"}}>
              <p className="flex-item font-weight-600 fs-16 color-white">Membership / Enquiry</p>
            </div>
            <div className="d-flex" style={{width:"15%"}}>
              <p className="flex-item font-weight-600 fs-16 color-white margin-auto">Follow-Up</p>
            </div>
            <div className="d-flex" style={{width:"25%"}}>
              <p className="flex-item font-weight-600 fs-16 color-white margin-auto">Action</p>
            </div>
          </div>
        )
      }
      <div className="w-full p-b-60">
        {
          customers.map((data,index) => {
            const active_memberships = [...(data.activeMembership || [])];
            const upcoming_memberships = [...(data.upcomingMembership || [])];
            const past_memberships = [...(data.pastMembership || [])];
            const freeze_memberships = [...(data.freezeMembership || [])];

            return(
              <div className="member-list-container d-flex-wrap space-between" >
                {
                  data.isEnquiry == true ? (
                    window.innerWidth > 640 ? (
                      <div onClick={()=>viewEnquiry(data?.userInfo?.phone)} className="flex-item cursor-pointer" style={{width:"20%"}}>
                        <p className="font-weight-700 fs-14 color-dark-blue">{data?.userInfo?.name || data?.userInfo?.full_name ||  "NA"}</p>
                      </div>
                    ) : (
                      <div className="d-flex w-full m-b-12 p-b-12" style={{borderBottom:"1px dashed #e0e0e0"}}>
                        <div className='table-item-profile d-flex flex-item m-r-8' style={{backgroundColor: "#5d883c"}}>
                          <p className='flex-item' style={{color: "#ffffff", margin: "0 auto", fontSize: 14, textTransform:"uppercase"}}>{`${data?.userInfo?.full_name}`.trim()[0]}</p>
                        </div>
                        <div onClick={()=>viewEnquiry(data?.userInfo?.phone)} className="flex-item cursor-pointer" style={{width: window.innerWidth > 640 ? "20%" : "80%"}}>
                          <p className="font-weight-700 fs-14 color-dark-blue">{data?.userInfo?.name || data?.userInfo?.full_name ||  "NA"}</p>
                          <p className="font-weight-400 fs-12">{data.userInfo && data.userInfo.phone ? data.userInfo.phone : "NA"}</p>
                        </div>
                      </div>
                    )
                  ) : (
                    window.innerWidth > 640 ? (
                      <a href={'/member/' + data._id} className="flex-item cursor-pointer" style={{width:"20%"}}>
                        <p className="font-weight-700 fs-14 color-dark-blue">{data?.userInfo?.name || data?.userInfo?.full_name ||  "NA"}</p>
                      </a> 
                    ) : (
                      <a href={'/member/' + data._id} className="d-flex w-full">
                        <div className='table-item-profile d-flex flex-item m-r-8' style={{backgroundColor: "#5d883c"}}>
                          <p className='flex-item' style={{color: "#ffffff", margin: "0 auto", fontSize: 14, textTransform:"uppercase"}}>{`${data?.userInfo?.full_name}`.trim()[0]}</p>
                        </div>
                        <div onClick={()=>viewEnquiry(data?.userInfo?.phone)} className="flex-item cursor-pointer" style={{width: window.innerWidth > 640 ? "20%" : "80%"}}>
                          <p className="font-weight-700 fs-14 color-dark-blue">{data?.userInfo?.name || data?.userInfo?.full_name ||  "NA"}</p>
                          <p className="font-weight-400 fs-12">{data.userInfo && data.userInfo.phone ? data.userInfo.phone : "NA"}</p>
                        </div>
                      </a>
                    )
                  )
                }

                {
                  window.innerWidth > 640 && (
                    <div className="flex-item d-flex" style={{width: window.innerWidth > 640 ? "15%" : "100%"}}>
                      <p className="font-weight-700 fs-14 color-dark-blue">{data.userInfo && data.userInfo.phone ? data.userInfo.phone : "NA"}</p>
                    </div>
                  )
                }
                
                {
                  (active_memberships?.length > 0 || upcoming_memberships?.length > 0 || past_memberships?.length > 0 || freeze_memberships?.length > 0) && !data.sourceOfEnquiry && (
                    <div className="d-flex-wrap" style={{width: window.innerWidth > 640 ? "25%" : "100%"}}>
                      {
                        window.innerWidth < 640 && (
                          <p className="flex-item m-t-12 font-weight-600 w-full m-b-4" style={{color:"#000000"}}>Memberships</p>
                        )
                      }
                      {
                        active_memberships?.length == 1 ? (
                          <div className='flex-item w-full'>
                            <p className='font-weight-700' style={{color: getMembershipColor(active_memberships[0])}}> {active_memberships?.[0].membershipplans?.[0]?.name?.length > 20
                              ? active_memberships?.[0]?.membershipplans?.[0]?.name.substring(0, 20) + "..."
                              : active_memberships?.[0]?.membershipplans?.[0]?.name}</p>
                            <p className='fs-12 color-grey-02'>{active_memberships?.[0]?.starts_at_string} - {active_memberships?.[0]?.ends_at_string}</p>
                          </div>
                        ) : active_memberships?.length > 1 ? (
                          window.innerWidth > 640 ? (
                            <div onClick={()=>handleViewMembershipList(index)} className='member-active-membership-container d-flex flex-item cursor-pointer' style={{background: selectedMembershipListIndex == index && "#055075"}}>
                              <p className="flex-item d-flex" style={{color:selectedMembershipListIndex == index ? "#ffffff" : ""}}>{active_memberships.length>1 && `${active_memberships.length} Active`}</p>
                              <svg className='flex-item svg-stroke m-l-12' style={{transform: selectedMembershipListIndex == index ? "rotate(180deg)" : "rotate(0deg)", transition:"180ms"}} width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.00001 1.00002L5.00001 4.50002L9.00001 1.00002" stroke={selectedMembershipListIndex == index ? "#ffffff" : "#000000"} stroke-width="2" stroke-linecap="round"/>
                              </svg>
                              {
                                (selectedMembershipListIndex == index && (active_memberships.length)>1) && [
                                  <div className="active-memberships-list scaleFromTopToBottom">
                                    {
                                      activeMemberships.map((membership, index) => {
                                        return(
                                          <div className='w-full p-b-6 p-t-6 cursor-pointer' style={{borderBottom: index + 1 != 5 && "1px solid #e0e0e0"}}>
                                            <p className='fs-14 color-dark-blue font-weight-600' style={{color:"var(--darkBlue)"}}>{membership?.membershipplans?.[0]?.name}</p>
                                            <p className='fs-12 color-grey-02'>{membership.starts_at_string} - {membership.ends_at_string}</p>
                                          </div>
                                        )
                                      })
                                    }
                                    {startActiveMembershipLoader && <div className="loader-5 center"><span></span></div>}
                                  </div>
                                ]
                              }
                            </div>
                          ) : (
                            <div className="flex-item w-full" style={{background:"#f5f5f5", borderRadius:"12px", padding:"12px 12px 0 12px"}}>
                              {
                                active_memberships.map((membership, index) => {
                                  return(
                                    <div className='flex-item w-full m-b-6 p-b-6' style={{borderBottom: index + 1 != active_memberships.length && "1px solid #e0e0e0"}}>
                                      <p className='font-weight-700' style={{color: getMembershipColor(active_memberships[0])}}>{membership?.membershipplans?.[0]?.name}</p>
                                      <p className='fs-12 color-grey-02'>{membership.starts_at_string} - {membership.ends_at_string}</p>
                                    </div>
                                  )
                                })
                              }
                            </div>
                          )
                        ) : <div className="flex-item d-flex" style={{width:"20%"}}>
                              <p className="font-weight-700 fs-14 margin-auto">{upcoming_memberships.length>0 ? <span className="color-yellow">Upcoming</span>: freeze_memberships.length>0 ? <span className="color-black">Freeze</span>  : past_memberships.length?  <span className="color-red">Expired</span>: <span className="color-black">-</span>}</p>
                            </div>
                      }
                    </div>
                  )
                }

                {
                  data.sourceOfEnquiry && (
                    <div className="flex-item" style={{width:window.innerWidth > 640 ? "25%" : "100%"}}>
                      {
                        window.innerWidth > 640 ? [
                          <p className="font-weight-700 color-dark-blue">Source: {data.sourceOfEnquiry}</p>,
                          <p className="font-weight-500 color-dark-blue fs-12">{formatDateAndTime(data.createdAt)}</p>
                        ] : (
                          <div className="w-full">
                            <div className="d-flex space-between">
                              <p className="font-weight-600 color-grey-02" style={{width:"36%"}}>Source:</p>
                              <p className="font-weight-700" style={{width:"60%"}}>{data.sourceOfEnquiry}</p>
                            </div>
                            <div className="d-flex space-between">
                              <p className="font-weight-600 color-grey-02" style={{width:"36%"}}>Created At:</p>
                              <p className="font-weight-700" style={{width:"60%"}}>{formatDateAndTime(data.createdAt)}</p>
                            </div>
                          </div>
                        )
                      }
                    </div>
                  )
                }

                {
                  window.innerWidth > 640 ? [
                    <div className="d-flex" style={{width:"15%"}}>
                      <div onClick={()=>handleCheckFollowUp(data?.userInfo?.phone)} className="d-flex member-button-global flex-item margin-auto" style={{boxShadow:"0px 0px 8px rgba(0,0,0,0.24)", textDecoration:"none"}}>
                        <p className="flex-item font-weight-700 fs-16" style={{textDecoration:"none"}}>View {window.innerWidth > 640 && "Follow Ups"}</p>
                      </div>
                    </div>, 
                    <div className="d-flex" style={{width: "25%"}}>
                      <div onClick={()=>handleCloseMembership(data)} className="d-flex member-button-global flex-item margin-auto" style={{boxShadow:"0px 0px 8px rgba(0,0,0,0.24)", textDecoration:"none"}}>
                        <p className="flex-item font-weight-700 fs-16" style={{textDecoration:"none"}}>Add / Renew Membership</p>
                      </div>
                    </div>
                  ] : (
                    <div className="d-flex w-full m-t-16">
                      <div onClick={()=>handleCheckFollowUp(data?.userInfo?.phone)} className="d-flex member-button-global flex-item m-r-12" style={{boxShadow:"0px 0px 8px rgba(0,0,0,0.24)", textDecoration:"none"}}>
                        <p className="flex-item font-weight-700 fs-16" style={{textDecoration:"none"}}>View {window.innerWidth > 640 && "Follow Ups"}</p>
                      </div>
                       <div onClick={()=>handleCloseMembership(data)} className="d-flex member-button-global flex-item" style={{boxShadow:"0px 0px 8px rgba(0,0,0,0.24)", textDecoration:"none"}}>
                        <p className="flex-item font-weight-700 fs-16" style={{textDecoration:"none"}}>Add / Renew Membership</p>
                      </div>
                    </div>
                  )
                }


                {/* <div className="flex-item d-flex" style={{width:"20%"}}>
                  <p className="font-weight-700 fs-14 margin-auto">{data.membership_count && data.membership_count.length > 0 && data.membership_count[0].count > 0 ? <span className="color-green">{data.membership_count[0].count + " Active"}</span> : <span className="color-red">Expired</span>}</p>
                </div> */}
                
              </div>
            )
          })
        }
        
        {isMemberSpinnerLoader && <div className="loader-5 center"><span></span></div>}

        {
          customers.length == 0 && (
            <div className="d-flex">
              <p className="flex-item margin-auto fs-16 color-red font-weight-700 p-t-60">Oops! No Member found</p>
            </div>
          )
        }
      </div>
      <div className="d-flex" style={{position:"sticky",bottom:0, left:0, zIndex:2, background:"#fff3f3", padding:"12px"}}>
        <div onClick={()=>toggleEnquiryModal()} className="d-flex member-button-global member-button-global-active flex-item m-r-20" style={{background:"var(--red)"}}>
          <svg className="flex-item m-r-12" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 8H1C0.71667 8 0.479337 7.904 0.288004 7.712C0.0966702 7.52 0.000670115 7.28267 3.44827e-06 7C-0.000663218 6.71734 0.0953369 6.48 0.288004 6.288C0.48067 6.096 0.718003 6 1 6H6V1C6 0.71667 6.096 0.479337 6.288 0.288004C6.48 0.0966702 6.71734 0.000670115 7 3.44827e-06C7.28267 -0.000663218 7.52034 0.0953369 7.713 0.288004C7.90567 0.48067 8.00134 0.718003 8 1V6H13C13.2833 6 13.521 6.096 13.713 6.288C13.905 6.48 14.0007 6.71734 14 7C13.9993 7.28267 13.9033 7.52034 13.712 7.713C13.5207 7.90567 13.2833 8.00134 13 8H8V13C8 13.2833 7.904 13.521 7.712 13.713C7.52 13.905 7.28267 14.0007 7 14C6.71734 13.9993 6.48 13.9033 6.288 13.712C6.096 13.5207 6 13.2833 6 13V8Z" fill="white"/>
          </svg>
          <p className="flex-item font-weight-700 fs-16" style={{color:"#ffffff"}}>New Enquiry</p>
        </div>
        <div onClick={()=>handleNewSaleModal()} className="d-flex member-button-global member-button-global-active flex-item" style={{background:"var(--red)"}}>
          <svg className="flex-item m-r-12" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 8H1C0.71667 8 0.479337 7.904 0.288004 7.712C0.0966702 7.52 0.000670115 7.28267 3.44827e-06 7C-0.000663218 6.71734 0.0953369 6.48 0.288004 6.288C0.48067 6.096 0.718003 6 1 6H6V1C6 0.71667 6.096 0.479337 6.288 0.288004C6.48 0.0966702 6.71734 0.000670115 7 3.44827e-06C7.28267 -0.000663218 7.52034 0.0953369 7.713 0.288004C7.90567 0.48067 8.00134 0.718003 8 1V6H13C13.2833 6 13.521 6.096 13.713 6.288C13.905 6.48 14.0007 6.71734 14 7C13.9993 7.28267 13.9033 7.52034 13.712 7.713C13.5207 7.90567 13.2833 8.00134 13 8H8V13C8 13.2833 7.904 13.521 7.712 13.713C7.52 13.905 7.28267 14.0007 7 14C6.71734 13.9993 6.48 13.9033 6.288 13.712C6.096 13.5207 6 13.2833 6 13V8Z" fill="white"/>
          </svg>
          <p className="flex-item font-weight-700 fs-16" style={{color:"#ffffff"}}>New Sale</p>
        </div>
      </div> 
    </div>,
    // isEnquiryModalOpen && (
    //   <ManageEnquiry phoneNo={props.searchInput.length > 0 && props.searchInput.length < 11 ?  props.searchInput : ""} handleCloseModal={toggleEnquiryModal}/>
    // ),
      isEnquiryModalOpen && (
        window.innerWidth > 580 ? (
          <ManageEnquiry phoneNo={props.searchInput.length > 0 && props.searchInput.length < 11 ?  props.searchInput : ""} handleCloseModal={toggleEnquiryModal}/>
        ) : (
          (() => {
            console.log("Mobile branch — searchInput:", props.searchInput, "width:", window.innerWidth);
            return (
              <ModalDrawer modalType="manage-enquiry" modalHeader="New Enquiry" phoneNo={props.searchInput.length > 0 && props.searchInput.length < 11 ? props.searchInput : ""} handleCloseModal={toggleEnquiryModal} />
            );
          })()
        )
      ),
   
   isNewSale && (
     window.innerWidth > 580 ? (
        <ManageEnquiry type="new-sales" phoneNo={props.searchInput.length > 0 && props.searchInput.length < 11 ? props.searchInput : ""} handleCloseModal={toggleNewSalesModal} handleNewSale={handleNewSale} />
      ) : (
        <ModalDrawer modalType="manage-enquiry" modalHeader="New Sale" type="new-sales" phoneNo={props.searchInput.length > 0 && props.searchInput.length < 11 ? props.searchInput : ""} handleCloseModal={toggleNewSalesModal} handleNewSale={handleNewSale} />
      )
    ),
    isCloseNewSale && selectedEnquiry != "" && (
      window.innerWidth > 580 ? (
        <MembershipBillingController type="close-enquiry" selectedUsers={selectedEnquiry} handleCloseModal={handleCloseNewSalesBilling} handleCreatedMembershipId={handleCreatedMembershipId}/>
      ) : (
        <ModalDrawer modalType="close-enquiry" modalHeader="Close Enquiry" type="close-enquiry" selectedUsers={selectedEnquiry} handleCloseModal={handleCloseNewSalesBilling} handleCreatedMembershipId={handleCreatedMembershipId} />
      )
    ),
    isCloseMembershipModalOpen && activeMemberships && (
      <MembershipBillingController type="NEWSALE" selectedUsers={selectedMember} activeMemberships={activeMemberships} handleCloseModal={()=>closeMembershipAssignModal()} handleCreatedMembershipId={handleCreatedMembershipId}/>
    ),
    isPaymentBillVisible && billInfo != "" && (
      <PaymentSlip handleViewPaymentSlip={handleViewPaymentSlip} payment={billInfo}/>
    )
  ]
}

export default MemberSearch;